import { render } from "./StoreInformation.vue?vue&type=template&id=95a4503e&scoped=true"
import script from "./StoreInformation.vue?vue&type=script&lang=js"
export * from "./StoreInformation.vue?vue&type=script&lang=js"

import "./StoreInformation.vue?vue&type=style&index=0&id=95a4503e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95a4503e"]])

export default __exports__